// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  scroll-behavior: smooth;
  overflow-x: hidden;
}
*{
  margin:0;
  padding: 0;
  box-sizing: border-box;
  scroll-behavior:smooth;
  font-family: 'Inter';


}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
:root{
  /* text colors */
  --t-pink:#D22F7D;
  --t-white:#ffffff;
  --t-black:#191617;
  --t-lgrey:#969696;
  
  /* background colors */
  --bg-dpink:#D22F7D;
  --bg-lgrey:#F2F2F2;
  --bg-pink:#E6007E;
  --bg-lpink:#C93374C4;
  --bg-black:#000000;
  --bg-white:#FFFFFF;
  --bg-grey:#C4C4C4;
  --box_shadow:rgba(149, 157, 165, 0.2) 0px 8px 24px;

}


h1{
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 4.0rem;
  line-height: 4.18rem;
}

h2{
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 3.75rem;
  line-height: 4.375rem;
}

h3{
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 2.7rem;
  line-height: 3rem;
}

h4{
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 2.3rem;
  line-height: 3.5rem
}


h5{
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 1.75rem;
  line-height: 2.6rem;
}
/* //////px/16=rem */
h6{
  font-family: 'Arial';
font-style: normal;
font-weight: 400;
font-size: 1.44rem;
line-height: 2.25rem;
}
p{
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  font-size: 0.93rem;
  line-height: 1.625rem;
}

small{

  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  font-size: 0.9375rem;
  line-height: 1.6rem;
}
/* input{
  width: 100%;
  height: 100%;
  outline: none;
 border: 1px solid var(--bg-grey);
  padding: 0.7rem 1rem;
  border-radius: 4px;
  font-weight: 600;
  color: var(--t-black);
  font-size: 0.7rem;


}
input:focus{
  border: 1px solid var(--bg-dpink);

} */
select{
  width: 100%;
  height: 100%;
  outline: none;
  border: 1px solid var(--bg-grey);
  padding: 0.7rem 1rem;
  border-radius: 4px;
  font-weight: 600;
  outline: none;
  color: var(--t-black);
  font-size: 0.7rem;

}
section:focus{
  border: 1px solid var(--bg-dpink);
  
}

/* input[type="color"] {
	-webkit-appearance: none;
	border: none;
	width: 32px;
	height: 32px;

}
input[type="color"]::-webkit-color-swatch-wrapper {
	padding: 0;
}
input[type="color"]::-webkit-color-swatch {
	border: none;
  border-radius: 8px;

}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
} */

/* Firefox */
/* input[type=number] {
  -moz-appearance: textfield;
} */
textarea{
  width: 100%;
  height: 100%;
  outline: none;
  border: 1px solid var(--bg-grey);

  padding: 0.7rem 1rem;
  border-radius: 4px;
  font-weight: 600;
  outline: none;
  color: var(--t-black);
  font-size: 0.7rem;
}
textarea:focus{
  border: 1px solid var(--bg-dpink);


}

a{
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1rem;
  text-decoration: none;
  text-transform: capitalize;
  color: inherit;
}
a:hover{
  color: var(--t-lgrey);
}


.topic_text{
  font-family: 'Arial';
font-style: normal;
font-weight: 700;
font-size: 1.875rem;
line-height: 3rem;
}

.flex_row_reverse{
  display: flex;
  flex-direction: row-reverse;
  justify-content:space-between;
  gap:3rem;
}

.flex_row_sb{
  display:flex;
  justify-content:space-between;
  gap:3rem;
}


.flex_row_c{
  display:flex;
  justify-content:center;
  align-items: center;
  gap:3rem;
}

.flex_row_column{
  display:flex;
  flex-direction: column;
  justify-content:center;
  align-items: center;
  gap:3rem;
}

.btn{
  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  background-color: var(--bg-pink);
  color:var(--t-white);
  padding: 0.64rem 1rem 0.64rem 1rem;
  border: none;
  outline: none;
  cursor: pointer;
}

.btn:hover{
  background-color: var(--bg-grey);
  color: var(--t-black);
}

.secondary_btn{
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 15.84px;
  line-height: 16px;
  color:var(--bg-pink);
  background-color: transparent;
  padding: 0.64rem 1rem 0.64rem 1rem;
  border: none;
  outline: none;
  text-align: start;
  cursor: pointer;

}

.underLine{
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 0.5rem;
}



@media screen and (max-width: 950px){

  h1 {
      font-size: 3.125rem;
      line-height: 1.2;
  }
  h2{
    font-size: 2.65rem;
   }
   h3{
    font-size: 2.25rem;
  }
   h4{
    font-size: 1.5rem;
    line-height: 1.4;
   }
  h5{
    font-style: normal;
  font-size: 1.25rem;
  line-height: 1.5rem;
  }
  
  
  
  .btn{
      font-size: 0.875rem;
    padding: 0.82rem 2.1rem;
  
  }
  .secondary_btn{
    font-size: 0.875rem;
  padding: 0.82rem 2.1rem;
  
  
  }
  }`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;;;AAGtB;;AAEA;EACE;aACW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kDAAkD;;AAEpD;;;AAGA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB;AACF;;;AAGA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,oBAAoB;AACpB;EACE,oBAAoB;AACtB,kBAAkB;AAClB,gBAAgB;AAChB,kBAAkB;AAClB,oBAAoB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;GAgBG;AACH;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;;AAEnB;AACA;EACE,iCAAiC;;AAEnC;;AAEA;;;;;;;;;;;;;;;;;;;GAmBG;;AAEH,YAAY;AACZ;;GAEG;AACH;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gCAAgC;;EAEhC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,iCAAiC;;;AAGnC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;;AAGA;EACE,oBAAoB;AACtB,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,iBAAiB;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,QAAQ;AACV;;;AAGA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;EACpB,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;;AAEjB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;AAC/B;;;;AAIA;;EAEE;MACI,mBAAmB;MACnB,gBAAgB;EACpB;EACA;IACE,kBAAkB;GACnB;GACA;IACC,kBAAkB;EACpB;GACC;IACC,iBAAiB;IACjB,gBAAgB;GACjB;EACD;IACE,kBAAkB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB;;;;EAIA;MACI,mBAAmB;IACrB,uBAAuB;;EAEzB;EACA;IACE,mBAAmB;EACrB,uBAAuB;;;EAGvB;EACA","sourcesContent":["body {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: border-box;\n  scroll-behavior: smooth;\n  overflow-x: hidden;\n}\n*{\n  margin:0;\n  padding: 0;\n  box-sizing: border-box;\n  scroll-behavior:smooth;\n  font-family: 'Inter';\n\n\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n:root{\n  /* text colors */\n  --t-pink:#D22F7D;\n  --t-white:#ffffff;\n  --t-black:#191617;\n  --t-lgrey:#969696;\n  \n  /* background colors */\n  --bg-dpink:#D22F7D;\n  --bg-lgrey:#F2F2F2;\n  --bg-pink:#E6007E;\n  --bg-lpink:#C93374C4;\n  --bg-black:#000000;\n  --bg-white:#FFFFFF;\n  --bg-grey:#C4C4C4;\n  --box_shadow:rgba(149, 157, 165, 0.2) 0px 8px 24px;\n\n}\n\n\nh1{\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 4.0rem;\n  line-height: 4.18rem;\n}\n\nh2{\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 3.75rem;\n  line-height: 4.375rem;\n}\n\nh3{\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 2.7rem;\n  line-height: 3rem;\n}\n\nh4{\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 2.3rem;\n  line-height: 3.5rem\n}\n\n\nh5{\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 1.75rem;\n  line-height: 2.6rem;\n}\n/* //////px/16=rem */\nh6{\n  font-family: 'Arial';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 1.44rem;\nline-height: 2.25rem;\n}\np{\n  font-family: 'Arial';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 0.93rem;\n  line-height: 1.625rem;\n}\n\nsmall{\n\n  font-family: 'Arial';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 0.9375rem;\n  line-height: 1.6rem;\n}\n/* input{\n  width: 100%;\n  height: 100%;\n  outline: none;\n border: 1px solid var(--bg-grey);\n  padding: 0.7rem 1rem;\n  border-radius: 4px;\n  font-weight: 600;\n  color: var(--t-black);\n  font-size: 0.7rem;\n\n\n}\ninput:focus{\n  border: 1px solid var(--bg-dpink);\n\n} */\nselect{\n  width: 100%;\n  height: 100%;\n  outline: none;\n  border: 1px solid var(--bg-grey);\n  padding: 0.7rem 1rem;\n  border-radius: 4px;\n  font-weight: 600;\n  outline: none;\n  color: var(--t-black);\n  font-size: 0.7rem;\n\n}\nsection:focus{\n  border: 1px solid var(--bg-dpink);\n  \n}\n\n/* input[type=\"color\"] {\n\t-webkit-appearance: none;\n\tborder: none;\n\twidth: 32px;\n\theight: 32px;\n\n}\ninput[type=\"color\"]::-webkit-color-swatch-wrapper {\n\tpadding: 0;\n}\ninput[type=\"color\"]::-webkit-color-swatch {\n\tborder: none;\n  border-radius: 8px;\n\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n} */\n\n/* Firefox */\n/* input[type=number] {\n  -moz-appearance: textfield;\n} */\ntextarea{\n  width: 100%;\n  height: 100%;\n  outline: none;\n  border: 1px solid var(--bg-grey);\n\n  padding: 0.7rem 1rem;\n  border-radius: 4px;\n  font-weight: 600;\n  outline: none;\n  color: var(--t-black);\n  font-size: 0.7rem;\n}\ntextarea:focus{\n  border: 1px solid var(--bg-dpink);\n\n\n}\n\na{\n  font-family: 'Arial';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 0.875rem;\n  line-height: 1rem;\n  text-decoration: none;\n  text-transform: capitalize;\n  color: inherit;\n}\na:hover{\n  color: var(--t-lgrey);\n}\n\n\n.topic_text{\n  font-family: 'Arial';\nfont-style: normal;\nfont-weight: 700;\nfont-size: 1.875rem;\nline-height: 3rem;\n}\n\n.flex_row_reverse{\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content:space-between;\n  gap:3rem;\n}\n\n.flex_row_sb{\n  display:flex;\n  justify-content:space-between;\n  gap:3rem;\n}\n\n\n.flex_row_c{\n  display:flex;\n  justify-content:center;\n  align-items: center;\n  gap:3rem;\n}\n\n.flex_row_column{\n  display:flex;\n  flex-direction: column;\n  justify-content:center;\n  align-items: center;\n  gap:3rem;\n}\n\n.btn{\n  font-family: 'Arial';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 21px;\n  background-color: var(--bg-pink);\n  color:var(--t-white);\n  padding: 0.64rem 1rem 0.64rem 1rem;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\n.btn:hover{\n  background-color: var(--bg-grey);\n  color: var(--t-black);\n}\n\n.secondary_btn{\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 15.84px;\n  line-height: 16px;\n  color:var(--bg-pink);\n  background-color: transparent;\n  padding: 0.64rem 1rem 0.64rem 1rem;\n  border: none;\n  outline: none;\n  text-align: start;\n  cursor: pointer;\n\n}\n\n.underLine{\n  text-decoration: underline;\n  text-decoration-thickness: 2px;\n  text-underline-offset: 0.5rem;\n}\n\n\n\n@media screen and (max-width: 950px){\n\n  h1 {\n      font-size: 3.125rem;\n      line-height: 1.2;\n  }\n  h2{\n    font-size: 2.65rem;\n   }\n   h3{\n    font-size: 2.25rem;\n  }\n   h4{\n    font-size: 1.5rem;\n    line-height: 1.4;\n   }\n  h5{\n    font-style: normal;\n  font-size: 1.25rem;\n  line-height: 1.5rem;\n  }\n  \n  \n  \n  .btn{\n      font-size: 0.875rem;\n    padding: 0.82rem 2.1rem;\n  \n  }\n  .secondary_btn{\n    font-size: 0.875rem;\n  padding: 0.82rem 2.1rem;\n  \n  \n  }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
